module.exports = __webpack_public_path__ + "img/普通充电桩2.bedf4976.jpg";